import { attr, hasMany } from '@ember-data/model';
import DigitalAsset from './digital-asset.ts';
import type TASProgramInstanceModel from './tas-program-instance.ts';
import type TASApplicationModel from './tas-application.ts';
import type TASCourseModel from './tas-course.ts';
import type TasAssistanceModel from './tas-assistance.ts';
import { Type } from '@warp-drive/core-types/symbols';
import type AttachmentModel from './attachment.ts';
export default class TASAssetModel extends DigitalAsset {
  /*************************
   **  Relationships      **
   *************************/

  @hasMany('tas-program-instance', { async: false, inverse: 'tasAssets' })
  declare tasProgramInstances: TASProgramInstanceModel[];
  @hasMany('tas-application', { async: false, inverse: 'tasAssets' })
  declare tasApplications: TASApplicationModel[];
  @hasMany('tas-course', { async: false, inverse: 'tasAssets' })
  declare tasCourses: TASCourseModel[];
  @hasMany('tas-assistance', { async: false, inverse: 'tasAssets' })
  declare tasAssistances: TasAssistanceModel[];
  @hasMany('attachment', { async: false, inverse: null })
  declare attachments: AttachmentModel[];

  /*************************
   **  Attributes          **
   *************************/
  @attr declare filename: string;

  /*************************
   **  Computed Properties **
   *************************/

  get extension() {
    const parts = this.filename.split('.');
    return parts.length > 1 ? parts.pop()!.toLowerCase() : '';
  }

  [Type] = 'tas-asset' as const;
}
